import React from 'react';
import MarginGuardHeld from '../components/MarginGuardHeld';

// FIRST-RELEASE LEGACY UI PRESERVED, INACTIVE LINE COMMENTS ONLY
// Original source: 34b99b9f6e8d7980f6ee89d06ad8ba9515129386:frontend/src/pages/MarginGuardPage.js
// Original UTF-8 SHA256: 6cb13afc6e83e94a97c86f290951436e92b48ed9998e7098b7d8da0883a9c3db
// Held legacy UI cannot fetch, render historical scores, or execute a fallback.
// Restore only after verified tenant/staff access, current data, denial tests,
// independent review and explicit owner approval of restoration.
// BEGIN ORIGINAL SOURCE
// /**
//  * Margin Guard Dashboard Page
//  * 
//  * The default decision surface for Shopify merchants.
//  * Shows scores, fix list, breakdowns, and traces.
//  */
// 
// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import DOMPurify from 'dompurify';
// import {
//   Shield,
//   TrendingUp,
//   TrendingDown,
//   AlertTriangle,
//   Package,
//   Clock,
//   XCircle,
//   ChevronRight,
//   RefreshCw,
//   Share2,
//   Slack,
//   CheckCircle,
//   ArrowRight,
//   BarChart3,
//   Layers,
//   Truck,
//   MapPin,
//   Box,
//   X,
//   MessageSquare,
//   Bookmark,
//   Settings,
//   Mail,
//   FileText,
//   Calendar,
//   Eye,
//   Sparkles,
//   Send,
//   Link,
//   Download,
//   Copy,
//   ArrowLeft,
//   Check
// } from 'lucide-react';
// import { toast } from 'sonner';
// import TraceViewer from '../components/TraceViewer';
// 
// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
// 
// // Share Report Dropdown Component
// const ShareReportDropdown = ({ onShareLink, onEmail, onSavePdf }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [linkCopied, setLinkCopied] = useState(false);
//   const dropdownRef = useRef(null);
// 
//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);
// 
//   const handleShareLink = async () => {
//     const shareUrl = window.location.href;
//     try {
//       await navigator.clipboard.writeText(shareUrl);
//       setLinkCopied(true);
//       toast.success('Link copied to clipboard!');
//       setTimeout(() => setLinkCopied(false), 2000);
//     } catch (err) {
//       toast.error('Failed to copy link');
//     }
//   };
// 
//   const handleSavePdf = () => {
//     // Close dropdown immediately
//     setIsOpen(false);
//     
//     // Store original title and set PDF-friendly title
//     const originalTitle = document.title;
//     document.title = 'Commerce Index - Margin Guard Report';
//     
//     // Small delay to let dropdown close, then trigger print
//     setTimeout(() => {
//       window.print();
//       // Restore original title after print dialog closes
//       document.title = originalTitle;
//     }, 100);
//   };
// 
//   return (
//     <div className="relative" ref={dropdownRef}>
//       <button 
//         onClick={() => setIsOpen(!isOpen)}
//         className="rounded-xl border border-slate-700 bg-slate-900 px-4 py-2 text-sm font-semibold text-slate-100 hover:bg-slate-800 transition-colors flex items-center gap-2"
//       >
//         <Share2 className="w-4 h-4" />
//         Share Report
//       </button>
// 
//       {isOpen && (
//         <div className="absolute right-0 mt-2 w-56 rounded-xl border border-slate-700 bg-slate-900 shadow-xl z-50 overflow-hidden">
//           <div className="py-1">
//             <button
//               onClick={handleShareLink}
//               className="w-full px-4 py-3 text-left text-sm text-slate-200 hover:bg-slate-800 flex items-center gap-3 transition-colors"
//             >
//               {linkCopied ? (
//                 <Check className="w-4 h-4 text-emerald-400" />
//               ) : (
//                 <Link className="w-4 h-4 text-slate-400" />
//               )}
//               <div>
//                 <div className="font-medium">{linkCopied ? 'Link Copied!' : 'Copy Share Link'}</div>
//                 <div className="text-xs text-slate-500">Share this report via URL</div>
//               </div>
//             </button>
//             
//             <button
//               onClick={() => {
//                 onEmail?.();
//                 setIsOpen(false);
//               }}
//               className="w-full px-4 py-3 text-left text-sm text-slate-200 hover:bg-slate-800 flex items-center gap-3 transition-colors"
//             >
//               <Mail className="w-4 h-4 text-slate-400" />
//               <div>
//                 <div className="font-medium">Email Report</div>
//                 <div className="text-xs text-slate-500">Send to your inbox</div>
//               </div>
//             </button>
//             
//             <button
//               onClick={handleSavePdf}
//               className="w-full px-4 py-3 text-left text-sm text-slate-200 hover:bg-slate-800 flex items-center gap-3 transition-colors"
//             >
//               <Download className="w-4 h-4 text-slate-400" />
//               <div>
//                 <div className="font-medium">Save as PDF</div>
//                 <div className="text-xs text-slate-500">Download report</div>
//               </div>
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
// 
// // Score Tile Component with tooltip support
// const ScoreTile = ({ label, value, delta, icon: Icon, color = 'emerald', tooltip }) => {
//   const [showTooltip, setShowTooltip] = useState(false);
//   
//   const colorClasses = {
//     emerald: 'text-emerald-500 bg-emerald-500/10',
//     blue: 'text-blue-500 bg-blue-500/10',
//     violet: 'text-violet-500 bg-violet-500/10',
//     amber: 'text-amber-500 bg-amber-500/10',
//     rose: 'text-rose-500 bg-rose-500/10',
//   };
// 
//   const getDeltaColor = (d) => {
//     if (d > 0) return 'text-emerald-400';
//     if (d < 0) return 'text-rose-400';
//     return 'text-slate-400';
//   };
// 
//   const getDeltaIcon = (d) => {
//     if (d > 0) return <TrendingUp className="w-3 h-3" />;
//     if (d < 0) return <TrendingDown className="w-3 h-3" />;
//     return null;
//   };
// 
//   // Only show delta if it's a real number and not zero placeholder
//   const hasDelta = delta !== undefined && delta !== null && delta !== 0;
// 
//   return (
//     <div 
//       className="rounded-2xl border border-slate-800 bg-slate-900/40 p-4 hover:border-slate-700 transition-colors relative"
//       onMouseEnter={() => tooltip && setShowTooltip(true)}
//       onMouseLeave={() => setShowTooltip(false)}
//     >
//       {/* Tooltip */}
//       {showTooltip && tooltip && (
//         <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-xs text-slate-300 whitespace-nowrap z-50 shadow-lg">
//           {tooltip}
//           <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-1 border-4 border-transparent border-t-slate-800"></div>
//         </div>
//       )}
//       
//       <div className="flex items-center justify-between mb-2">
//         <span className="text-xs font-semibold uppercase tracking-wide text-slate-400 flex items-center gap-1">
//           {label}
//           {tooltip && <span className="text-slate-600 cursor-help">ⓘ</span>}
//         </span>
//         {Icon && (
//           <div className={`p-1.5 rounded-lg ${colorClasses[color]}`}>
//             <Icon className="w-4 h-4" />
//           </div>
//         )}
//       </div>
//       <div className="flex items-end justify-between">
//         <div className="text-3xl font-extrabold text-slate-100">
//           {typeof value === 'number' ? Math.round(value) : '—'}
//           <span className="ml-1 text-sm font-semibold text-slate-400">/100</span>
//         </div>
//         {hasDelta ? (
//           <div className={`flex items-center gap-1 text-sm font-medium ${getDeltaColor(delta)}`}>
//             {getDeltaIcon(delta)}
//             <span>{delta > 0 ? '+' : ''}{delta.toFixed(1)}</span>
//           </div>
//         ) : (
//           <span className="text-sm text-slate-600">—</span>
//         )}
//       </div>
//     </div>
//   );
// };
// 
// // Fix Item Card Component with category prefix and plan gating
// const FixItemCard = ({ item, onReviewTrace, onSendToSlack, onSnooze, onResolve, isSlackConnected = false, planAllowsSlack = false }) => {
//   const severityColors = {
//     high: 'border-rose-500/50 bg-rose-500/5',
//     medium: 'border-amber-500/50 bg-amber-500/5',
//     low: 'border-slate-600 bg-slate-800/30'
//   };
//   
//   const severityBadge = {
//     high: 'bg-rose-500/20 text-rose-400',
//     medium: 'bg-amber-500/20 text-amber-400',
//     low: 'bg-slate-600/50 text-slate-300'
//   };
// 
//   // Add category prefix for faster parsing
//   const getCategoryPrefix = (entityType) => {
//     const type = entityType?.toLowerCase() || '';
//     if (type.includes('node') || type.includes('3pl') || type.includes('warehouse')) return 'Node:';
//     if (type.includes('region') || type.includes('geo')) return 'Region:';
//     if (type.includes('method') || type.includes('shipping')) return 'Method:';
//     if (type.includes('sku') || type.includes('product')) return 'SKU:';
//     return '';
//   };
// 
//   const categoryPrefix = getCategoryPrefix(item.entity_type);
//   const canSendToSlack = isSlackConnected && planAllowsSlack;
// 
//   return (
//     <div className={`rounded-2xl border p-4 ${severityColors[item.severity]}`}>
//       <div className="flex items-start justify-between gap-4">
//         <div className="flex-1">
//           <div className="flex items-center gap-2 mb-1">
//             <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${severityBadge[item.severity]}`}>
//               {item.severity.toUpperCase()}
//             </span>
//             {categoryPrefix && (
//               <span className="text-xs font-semibold text-emerald-400">{categoryPrefix}</span>
//             )}
//             <span className="text-xs text-slate-500">{item.entity_type}</span>
//           </div>
//           <h4 className="text-base font-semibold text-slate-100 mb-1">{item.title}</h4>
//           <p className="text-sm text-slate-400 mb-2">{item.impact_label}</p>
//           <ul className="space-y-1">
//             {item.evidence.slice(0, 2).map((e, i) => (
//               <li key={i} className="flex items-start gap-2 text-sm text-slate-300">
//                 <span className="text-slate-500 mt-0.5">•</span>
//                 {e}
//               </li>
//             ))}
//           </ul>
//         </div>
//         
//         <div className="flex flex-col gap-2 shrink-0">
//           <button
//             onClick={() => onReviewTrace(item.trace_id)}
//             className="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl text-sm font-semibold transition-colors flex items-center gap-2"
//           >
//             Review Trace
//             <ChevronRight className="w-4 h-4" />
//           </button>
//           
//           <div className="relative group">
//             <button
//               onClick={() => canSendToSlack && onSendToSlack(item)}
//               disabled={!canSendToSlack}
//               className={`px-4 py-2 border rounded-xl text-sm font-semibold transition-colors flex items-center gap-2 w-full ${
//                 canSendToSlack 
//                   ? 'border-slate-700 bg-slate-900 hover:bg-slate-800 text-slate-100' 
//                   : 'border-slate-800 bg-slate-900/50 text-slate-500 cursor-not-allowed'
//               }`}
//             >
//               <Slack className="w-4 h-4" />
//               Send to Slack
//             </button>
//             {!canSendToSlack && (
//               <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-xs text-slate-300 whitespace-nowrap z-50 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity">
//                 {!planAllowsSlack ? 'Pro plan required' : 'Connect Slack in Settings'}
//                 <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-1 border-4 border-transparent border-t-slate-800"></div>
//               </div>
//             )}
//           </div>
//           
//           <button
//             onClick={() => onSnooze(item)}
//             className="px-4 py-2 border border-slate-800 bg-transparent hover:bg-slate-900/60 text-slate-300 rounded-xl text-sm font-medium transition-colors"
//           >
//             Snooze
//           </button>
//           
//           <button
//             onClick={() => onResolve(item)}
//             className="px-4 py-2 border border-slate-800 bg-transparent hover:bg-slate-900/60 text-slate-300 rounded-xl text-sm font-medium transition-colors"
//           >
//             Mark Resolved
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };
// 
// // Breakdown Tab Component
// const BreakdownTab = ({ active, label, icon: Icon, onClick }) => (
//   <button
//     onClick={onClick}
//     className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium transition-colors ${
//       active
//         ? 'bg-emerald-600 text-white'
//         : 'bg-slate-800 text-slate-300 hover:bg-slate-700'
//     }`}
//   >
//     <Icon className="w-4 h-4" />
//     {label}
//   </button>
// );
// 
// // Weekly Brief Card Component
// // Weekly Brief Card Component - No duplicate scoreboard (moved to modal only)
// const WeeklyBriefCard = ({ brief, onGenerate, onViewFull, onSendEmail, onSendSlack, generating, isSlackConnected = false, planAllowsSlack = false }) => {
//   const hasBrief = brief?.has_brief;
//   const briefData = brief?.brief;
//   
//   // Format the date
//   const formatDate = (dateStr) => {
//     if (!dateStr) return 'Not generated';
//     const date = new Date(dateStr);
//     return date.toLocaleDateString('en-US', { 
//       weekday: 'short', 
//       month: 'short', 
//       day: 'numeric',
//       hour: 'numeric',
//       minute: '2-digit'
//     });
//   };
// 
//   // Get next Monday at 7am for scheduled generation
//   const getNextScheduledDate = () => {
//     const now = new Date();
//     const daysUntilMonday = (8 - now.getDay()) % 7 || 7;
//     const nextMonday = new Date(now);
//     nextMonday.setDate(now.getDate() + daysUntilMonday);
//     nextMonday.setHours(7, 0, 0, 0);
//     return nextMonday.toLocaleDateString('en-US', { 
//       weekday: 'short', 
//       month: 'short', 
//       day: 'numeric',
//       hour: 'numeric',
//       minute: '2-digit'
//     });
//   };
// 
//   const canSendToSlack = isSlackConnected && planAllowsSlack;
// 
//   return (
//     <div className="rounded-3xl border border-slate-800 bg-gradient-to-br from-slate-900/80 to-slate-900/40 p-6 mb-8">
//       <div className="flex items-start justify-between gap-4 mb-4">
//         <div className="flex items-center gap-3">
//           <div className="p-3 rounded-2xl bg-gradient-to-br from-emerald-500/20 to-blue-500/20 border border-emerald-500/30">
//             <FileText className="w-6 h-6 text-emerald-400" />
//           </div>
//           <div>
//             <h2 className="text-xl font-bold text-slate-100 flex items-center gap-2">
//               Weekly Operator Brief
//               {hasBrief && <span className="px-2 py-0.5 bg-emerald-500/20 text-emerald-400 rounded-full text-xs font-medium">NEW</span>}
//             </h2>
//             <p className="text-sm text-slate-400">
//               {hasBrief 
//                 ? `Generated ${formatDate(briefData?.created_at)}`
//                 : 'Generate your weekly insights report'
//               }
//             </p>
//             <p className="text-xs text-slate-500 mt-0.5">
//               Next scheduled: {getNextScheduledDate()}
//             </p>
//           </div>
//         </div>
//         
//         <div className="flex items-center gap-2">
//           {hasBrief && (
//             <>
//               <button
//                 onClick={onSendEmail}
//                 className="p-2 rounded-xl border border-slate-700 bg-slate-800 hover:bg-slate-700 text-slate-300 hover:text-white transition-colors"
//                 title="Send via Email"
//               >
//                 <Mail className="w-4 h-4" />
//               </button>
//               <div className="relative group">
//                 <button
//                   onClick={() => canSendToSlack && onSendSlack()}
//                   disabled={!canSendToSlack}
//                   className={`p-2 rounded-xl border transition-colors ${
//                     canSendToSlack 
//                       ? 'border-slate-700 bg-slate-800 hover:bg-slate-700 text-slate-300 hover:text-white' 
//                       : 'border-slate-800 bg-slate-900/50 text-slate-600 cursor-not-allowed'
//                   }`}
//                   title="Post to Slack"
//                 >
//                   <Slack className="w-4 h-4" />
//                 </button>
//                 {!canSendToSlack && (
//                   <div className="absolute bottom-full right-0 mb-2 px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-xs text-slate-300 whitespace-nowrap z-50 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity">
//                     {!planAllowsSlack ? 'Pro plan required' : 'Connect Slack in Settings'}
//                   </div>
//                 )}
//               </div>
//             </>
//           )}
//           <button
//             onClick={onGenerate}
//             disabled={generating}
//             className="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 disabled:bg-emerald-600/50 text-white rounded-xl text-sm font-semibold transition-colors flex items-center gap-2"
//           >
//             {generating ? (
//               <>
//                 <RefreshCw className="w-4 h-4 animate-spin" />
//                 Generating...
//               </>
//             ) : (
//               <>
//                 <Sparkles className="w-4 h-4" />
//                 {hasBrief ? 'Generate Latest' : 'Generate Now'}
//               </>
//             )}
//           </button>
//         </div>
//       </div>
// 
//       {hasBrief ? (
//         <>
//           {/* Brief Summary - NO scoreboard here, just counts */}
//           <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
//             {/* Top Fixes Count */}
//             <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-4">
//               <div className="flex items-center gap-2 mb-3">
//                 <AlertTriangle className="w-4 h-4 text-amber-400" />
//                 <h3 className="text-sm font-semibold text-slate-300">Top Fixes ({briefData?.fix_list?.length || 0})</h3>
//               </div>
//               <div className="space-y-2">
//                 {briefData?.fix_list?.slice(0, 2).map((fix, idx) => (
//                   <div key={idx} className="flex items-start gap-2">
//                     <span className={`px-1.5 py-0.5 rounded text-[10px] font-bold ${
//                       fix.severity === 'high' ? 'bg-rose-500/20 text-rose-400' :
//                       fix.severity === 'medium' ? 'bg-amber-500/20 text-amber-400' :
//                       'bg-slate-600/50 text-slate-400'
//                     }`}>
//                       {fix.severity?.charAt(0).toUpperCase()}
//                     </span>
//                     <span className="text-xs text-slate-300 line-clamp-1">{fix.title}</span>
//                   </div>
//                 ))}
//                 {(!briefData?.fix_list || briefData?.fix_list?.length === 0) && (
//                   <div className="flex items-center gap-2 text-emerald-400 text-xs">
//                     <CheckCircle className="w-3 h-3" />
//                     All clear this week!
//                   </div>
//                 )}
//               </div>
//             </div>
// 
//             {/* Watchlist Counts */}
//             <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-4">
//               <div className="flex items-center gap-2 mb-3">
//                 <Eye className="w-4 h-4 text-violet-400" />
//                 <h3 className="text-sm font-semibold text-slate-300">Watchlist (7d)</h3>
//               </div>
//               <div className="space-y-2">
//                 <div className="flex items-center justify-between">
//                   <span className="text-xs text-slate-500">Late-risk orders</span>
//                   <span className="text-sm font-semibold text-slate-200">{briefData?.watchlist?.late_risk_count || 0}</span>
//                 </div>
//                 <div className="flex items-center justify-between">
//                   <span className="text-xs text-slate-500">Backorder SKUs</span>
//                   <span className="text-sm font-semibold text-slate-200">{briefData?.watchlist?.backorder_sku_count || 0}</span>
//                 </div>
//                 <div className="flex items-center justify-between">
//                   <span className="text-xs text-slate-500">PCR spikes</span>
//                   <span className="text-sm font-semibold text-slate-200">{briefData?.watchlist?.pcr_spike_count || 0}</span>
//                 </div>
//               </div>
//             </div>
// 
//             {/* Expectation Gap */}
//             <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-4">
//               <div className="flex items-center gap-2 mb-3">
//                 <TrendingDown className="w-4 h-4 text-rose-400" />
//                 <h3 className="text-sm font-semibold text-slate-300 flex items-center gap-1">
//                   Expectation Gap
//                   <span className="text-slate-600 cursor-help text-xs" title="Late by customer expectation but within policy">ⓘ</span>
//                 </h3>
//               </div>
//               <div className="space-y-2">
//                 <div className="flex items-center justify-between">
//                   <span className="text-xs text-slate-500">Gap orders</span>
//                   <span className="text-sm font-semibold text-slate-200">{briefData?.expectation_gap?.count || 0}</span>
//                 </div>
//                 <div className="flex items-center justify-between">
//                   <span className="text-xs text-slate-500">Top driver</span>
//                   <span className="text-sm font-semibold text-slate-200 truncate max-w-[100px]">{briefData?.expectation_gap?.top_driver || '—'}</span>
//                 </div>
//               </div>
//             </div>
//           </div>
// 
//           {/* Subject Line Preview */}
//           <div className="flex items-center justify-between p-3 rounded-xl bg-slate-800/50 border border-slate-700">
//             <div className="flex items-center gap-3">
//               <Mail className="w-4 h-4 text-slate-500" />
//               <span className="text-sm text-slate-300 font-medium">{briefData?.subject || 'Weekly Operator Brief'}</span>
//             </div>
//             <button
//               onClick={onViewFull}
//               className="text-sm text-emerald-400 hover:text-emerald-300 font-medium flex items-center gap-1"
//             >
//               View Full Brief
//               <ChevronRight className="w-4 h-4" />
//             </button>
//           </div>
//         </>
//       ) : (
//         /* No Brief State */
//         <div className="text-center py-8">
//           <div className="w-16 h-16 rounded-full bg-slate-800 flex items-center justify-center mx-auto mb-4">
//             <Calendar className="w-8 h-8 text-slate-500" />
//           </div>
//           <p className="text-slate-400 mb-2">No operator brief generated yet</p>
//           <p className="text-xs text-slate-500 mb-4">
//             Briefs are automatically generated every Monday at 7:00 AM,<br />
//             or you can generate one now to see your weekly insights.
//           </p>
//         </div>
//       )}
//     </div>
//   );
// };
// 
// // Full Brief Modal Component
// const FullBriefModal = ({ brief, isOpen, onClose }) => {
//   if (!isOpen || !brief) return null;
// 
//   const briefData = brief?.brief || brief;
// 
//   const severityColors = {
//     high: 'border-rose-500/50 bg-rose-500/10 text-rose-400',
//     medium: 'border-amber-500/50 bg-amber-500/10 text-amber-400',
//     low: 'border-slate-600 bg-slate-800/30 text-slate-400'
//   };
// 
//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
//       <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
//       <div className="relative w-full max-w-4xl max-h-[90vh] overflow-y-auto rounded-3xl border border-slate-700 bg-slate-900 shadow-2xl">
//         {/* Header */}
//         <div className="sticky top-0 bg-slate-900 border-b border-slate-800 p-6 flex items-center justify-between">
//           <div>
//             <h2 className="text-2xl font-bold text-slate-100">Operator Brief</h2>
//             <p className="text-sm text-slate-400">{briefData?.subject}</p>
//           </div>
//           <button
//             onClick={onClose}
//             className="p-2 rounded-xl hover:bg-slate-800 text-slate-400 hover:text-white transition-colors"
//           >
//             <X className="w-6 h-6" />
//           </button>
//         </div>
// 
//         <div className="p-6 space-y-6">
//           {/* Scoreboard */}
//           <div>
//             <h3 className="text-lg font-bold text-slate-100 mb-4 flex items-center gap-2">
//               <BarChart3 className="w-5 h-5 text-blue-400" />
//               Scoreboard (0-100)
//             </h3>
//             <div className="grid grid-cols-5 gap-3">
//               {[
//                 { key: 'margin_guard', label: 'Margin Guard', icon: Shield, color: 'emerald' },
//                 { key: 'promise_business', label: 'Promise', icon: Clock, color: 'blue' },
//                 { key: 'expectation_calendar', label: 'Expectation', icon: TrendingUp, color: 'violet' },
//                 { key: 'pcr', label: 'PCR', icon: XCircle, color: 'amber' },
//                 { key: 'backorder', label: 'Backorder', icon: Package, color: 'rose' }
//               ].map(({ key, label, icon: Icon, color }) => (
//                 <div key={key} className="rounded-xl border border-slate-800 bg-slate-800/50 p-3 text-center">
//                   <Icon className={`w-4 h-4 mx-auto mb-1 text-${color}-400`} />
//                   <div className="text-2xl font-bold text-slate-100">{briefData?.scores?.[key] || '—'}</div>
//                   <div className="text-xs text-slate-500">{label}</div>
//                   {briefData?.deltas?.[key] !== undefined && (
//                     <div className={`text-xs font-medium mt-1 ${briefData?.deltas?.[key] >= 0 ? 'text-emerald-400' : 'text-rose-400'}`}>
//                       {briefData?.deltas?.[key] >= 0 ? '↑' : '↓'}{Math.abs(briefData?.deltas?.[key]).toFixed(0)} vs 7d
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>
//           </div>
// 
//           {/* Fix List */}
//           <div>
//             <h3 className="text-lg font-bold text-slate-100 mb-4 flex items-center gap-2">
//               <AlertTriangle className="w-5 h-5 text-amber-400" />
//               This Week's Fix List
//             </h3>
//             {briefData?.fix_list?.length > 0 ? (
//               <div className="space-y-3">
//                 {briefData?.fix_list?.map((fix, idx) => (
//                   <div key={idx} className={`rounded-xl border p-4 ${severityColors[fix.severity]}`}>
//                     <div className="flex items-start justify-between">
//                       <div>
//                         <div className="flex items-center gap-2 mb-1">
//                           <span className={`px-2 py-0.5 rounded-full text-xs font-bold uppercase ${severityColors[fix.severity]}`}>
//                             {fix.severity}
//                           </span>
//                         </div>
//                         <h4 className="text-base font-semibold text-slate-100">{fix.title}</h4>
//                         {fix.impact && (
//                           <p className="text-sm text-slate-400 mt-1">
//                             Impact: {fix.impact.orders_at_risk || fix.impact.ordersAtRisk} orders at risk
//                             {fix.impact.est_weekly_usd_high && ` (~$${fix.impact.est_weekly_usd_high.toLocaleString()})`}
//                           </p>
//                         )}
//                         {fix.evidence?.length > 0 && (
//                           <ul className="mt-2 space-y-1">
//                             {fix.evidence.map((e, i) => (
//                               <li key={i} className="text-sm text-slate-300 flex items-start gap-2">
//                                 <span className="text-slate-500">•</span> {e}
//                               </li>
//                             ))}
//                           </ul>
//                         )}
//                         {fix.recommended_options?.length > 0 && (
//                           <div className="mt-3">
//                             <p className="text-xs font-semibold text-slate-500 mb-1">Recommended Actions:</p>
//                             <div className="flex flex-wrap gap-2">
//                               {fix.recommended_options.map((opt, i) => (
//                                 <span key={i} className="px-2 py-1 rounded-lg bg-slate-800 text-xs text-slate-300">
//                                   {opt.label}
//                                 </span>
//                               ))}
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <div className="text-center py-6 rounded-xl border border-slate-800 bg-slate-800/30">
//                 <CheckCircle className="w-8 h-8 text-emerald-400 mx-auto mb-2" />
//                 <p className="text-slate-300">All clear this week!</p>
//               </div>
//             )}
//           </div>
// 
//           {/* Watchlist & Expectation Gap */}
//           <div className="grid grid-cols-2 gap-4">
//             <div className="rounded-xl border border-slate-800 bg-slate-800/30 p-4">
//               <h3 className="text-base font-bold text-slate-100 mb-3 flex items-center gap-2">
//                 <Eye className="w-4 h-4 text-violet-400" />
//                 Watchlist (Next 7 Days)
//               </h3>
//               <div className="space-y-2">
//                 <div className="flex justify-between">
//                   <span className="text-sm text-slate-400">Late-risk orders</span>
//                   <span className="text-sm font-semibold text-slate-200">{briefData?.watchlist?.late_risk_count || 0}</span>
//                 </div>
//                 <div className="flex justify-between">
//                   <span className="text-sm text-slate-400">Backorder-risk SKUs</span>
//                   <span className="text-sm font-semibold text-slate-200">{briefData?.watchlist?.backorder_sku_count || 0}</span>
//                 </div>
//                 <div className="flex justify-between">
//                   <span className="text-sm text-slate-400">PCR spikes</span>
//                   <span className="text-sm font-semibold text-slate-200">{briefData?.watchlist?.pcr_spike_count || 0}</span>
//                 </div>
//               </div>
//             </div>
// 
//             <div className="rounded-xl border border-slate-800 bg-slate-800/30 p-4">
//               <h3 className="text-base font-bold text-slate-100 mb-3 flex items-center gap-2">
//                 <TrendingDown className="w-4 h-4 text-rose-400" />
//                 Expectation Gap (CSAT Risk)
//               </h3>
//               <div className="space-y-2">
//                 <div className="flex justify-between">
//                   <span className="text-sm text-slate-400">Gap orders</span>
//                   <span className="text-sm font-semibold text-slate-200">{briefData?.expectation_gap?.count || 0}</span>
//                 </div>
//                 <div className="flex justify-between">
//                   <span className="text-sm text-slate-400">Top driver</span>
//                   <span className="text-sm font-semibold text-slate-200">{briefData?.expectation_gap?.top_driver || '—'}</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
// 
//         {/* Footer */}
//         <div className="sticky bottom-0 bg-slate-900 border-t border-slate-800 p-4 flex justify-end gap-3">
//           <button
//             onClick={onClose}
//             className="px-4 py-2 border border-slate-700 bg-slate-800 hover:bg-slate-700 text-slate-200 rounded-xl text-sm font-medium transition-colors"
//           >
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };
// 
// // Trace Drawer Component
// const TraceDrawer = ({ traceId, trace, onClose }) => {
//   if (!trace) return null;
// 
//   return (
//     <div className="fixed inset-0 z-50 flex">
//       <div className="flex-1 bg-black/50 backdrop-blur-sm" onClick={onClose} />
//       <div className="w-full max-w-2xl border-l border-slate-800 bg-slate-950 overflow-y-auto">
//         <div className="sticky top-0 bg-slate-950 border-b border-slate-800 p-4 flex items-center justify-between">
//           <div>
//             <h3 className="text-lg font-bold text-slate-100">Trace Details</h3>
//             <p className="text-sm text-slate-400">{trace.root}</p>
//           </div>
//           <button
//             onClick={onClose}
//             className="p-2 rounded-lg hover:bg-slate-800 text-slate-400 hover:text-white transition-colors"
//           >
//             <X className="w-5 h-5" />
//           </button>
//         </div>
//         
//         <div className="p-6">
//           {/* Summary */}
//           <div className="mb-6 p-4 rounded-xl bg-slate-900/50 border border-slate-800">
//             <h4 className="text-sm font-semibold text-slate-400 mb-2">Summary</h4>
//             <p className="text-slate-200">{trace.summary}</p>
//           </div>
//           
//           {/* Narrative */}
//           <div className="prose prose-invert prose-sm max-w-none">
//             <div 
//               className="text-slate-300"
//               dangerouslySetInnerHTML={{
//                 __html: DOMPurify.sanitize(
//                   trace.narrative
//                     .replace(/## /g, '<h4 class="text-lg font-bold text-slate-100 mt-6 mb-3">')
//                     .replace(/\*\*(.*?)\*\*/g, '<strong class="text-white">$1</strong>')
//                     .replace(/\n1\. /g, '<br/><span class="text-emerald-400">1.</span> ')
//                     .replace(/\n2\. /g, '<br/><span class="text-emerald-400">2.</span> ')
//                     .replace(/\n3\. /g, '<br/><span class="text-emerald-400">3.</span> ')
//                     .replace(/\n/g, '<br/>')
//                 )
//               }}
//             />
//           </div>
//           
//           {/* Actions */}
//           <div className="mt-6 flex gap-3">
//             <button className="flex-1 px-4 py-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl font-semibold transition-colors flex items-center justify-center gap-2">
//               <CheckCircle className="w-5 h-5" />
//               Mark Resolved
//             </button>
//             <button className="px-4 py-3 border border-slate-700 bg-slate-900 hover:bg-slate-800 text-slate-100 rounded-xl font-semibold transition-colors flex items-center gap-2">
//               <Bookmark className="w-5 h-5" />
//               Save Precedent
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
// 
// // Main Margin Guard Page
// export default function MarginGuardPage() {
//   const navigate = useNavigate();
//   const { traceId: urlTraceId } = useParams();
//   const [period, setPeriod] = useState('7d');
//   const [loading, setLoading] = useState(true);
//   const [summary, setSummary] = useState(null);
//   const [breakdownType, setBreakdownType] = useState('node');
//   const [breakdowns, setBreakdowns] = useState([]);
//   const [selectedTraceId, setSelectedTraceId] = useState(urlTraceId || null);
//   const [trace, setTrace] = useState(null);
//   const [refreshing, setRefreshing] = useState(false);
//   
//   // Brief state
//   const [brief, setBrief] = useState(null);
//   const [briefLoading, setBriefLoading] = useState(false);
//   const [generatingBrief, setGeneratingBrief] = useState(false);
//   const [showFullBrief, setShowFullBrief] = useState(false);
//   
//   // Handle URL-based trace opening
//   useEffect(() => {
//     if (urlTraceId) {
//       setSelectedTraceId(urlTraceId);
//     }
//   }, [urlTraceId]);
// 
//   // Fetch latest brief
//   const fetchBrief = async () => {
//     setBriefLoading(true);
//     try {
//       const res = await fetch(`${BACKEND_URL}/api/margin-guard/briefs/latest?brand_id=demo-brand`);
//       if (res.ok) {
//         const data = await res.json();
//         setBrief(data);
//       }
//     } catch (error) {
//       console.error('Error fetching brief:', error);
//     } finally {
//       setBriefLoading(false);
//     }
//   };
// 
//   // Generate brief on-demand
//   const handleGenerateBrief = async () => {
//     setGeneratingBrief(true);
//     try {
//       const res = await fetch(`${BACKEND_URL}/api/margin-guard/briefs/generate?brand_id=demo-brand&force_regenerate=true`, {
//         method: 'POST'
//       });
//       if (res.ok) {
//         const data = await res.json();
//         toast.success('Operator Brief generated successfully!');
//         // Refresh the brief display
//         await fetchBrief();
//       } else {
//         const error = await res.json();
//         toast.error(error.detail || 'Failed to generate brief');
//       }
//     } catch (error) {
//       console.error('Error generating brief:', error);
//       toast.error('Failed to generate brief');
//     } finally {
//       setGeneratingBrief(false);
//     }
//   };
// 
//   // Send brief via email
//   const handleSendBriefEmail = async () => {
//     if (!brief?.brief?.brief_id) {
//       toast.error('No brief available to send');
//       return;
//     }
//     try {
//       const res = await fetch(`${BACKEND_URL}/api/margin-guard/briefs/${brief.brief.brief_id}/send-email`, {
//         method: 'POST'
//       });
//       if (res.ok) {
//         toast.success('Brief sent via email!');
//       } else {
//         const error = await res.json();
//         toast.error(error.detail || 'Failed to send email');
//       }
//     } catch (error) {
//       toast.error('Failed to send email');
//     }
//   };
// 
//   // Post brief to Slack
//   const handleSendBriefSlack = async () => {
//     if (!brief?.brief?.brief_id) {
//       toast.error('No brief available to post');
//       return;
//     }
//     // For now, show a message about Slack not being connected
//     toast.info('Connect Slack in Settings to enable this feature');
//   };
// 
//   // Fetch summary data
//   const fetchSummary = async () => {
//     try {
//       const res = await fetch(`${BACKEND_URL}/api/margin-guard/summary?period=${period}`);
//       if (res.ok) {
//         const data = await res.json();
//         setSummary(data);
//       }
//     } catch (error) {
//       console.error('Error fetching margin guard summary:', error);
//       toast.error('Failed to load Margin Guard data');
//     } finally {
//       setLoading(false);
//     }
//   };
// 
//   // Fetch breakdowns
//   const fetchBreakdowns = async () => {
//     try {
//       const res = await fetch(`${BACKEND_URL}/api/margin-guard/breakdowns?breakdown_by=${breakdownType}&period=${period}`);
//       if (res.ok) {
//         const data = await res.json();
//         setBreakdowns(data.metrics || []);
//       }
//     } catch (error) {
//       console.error('Error fetching breakdowns:', error);
//     }
//   };
// 
//   // Fetch trace
//   const fetchTrace = async (traceId) => {
//     try {
//       const res = await fetch(`${BACKEND_URL}/api/margin-guard/traces/${traceId}`);
//       if (res.ok) {
//         const data = await res.json();
//         setTrace(data);
//       }
//     } catch (error) {
//       console.error('Error fetching trace:', error);
//       toast.error('Failed to load trace');
//     }
//   };
// 
//   // Handle refresh
//   const handleRefresh = async () => {
//     setRefreshing(true);
//     await fetchSummary();
//     await fetchBreakdowns();
//     setRefreshing(false);
//     toast.success('Data refreshed');
//   };
// 
//   // Handle trace view
//   const handleReviewTrace = (traceId) => {
//     setSelectedTraceId(traceId);
//     fetchTrace(traceId);
//   };
// 
//   // Handle actions
//   const handleSendToSlack = (item) => {
//     toast.success(`Sent "${item.title}" to Slack`);
//   };
// 
//   const handleSnooze = async (item) => {
//     try {
//       await fetch(`${BACKEND_URL}/api/margin-guard/decisions`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           trace_id: item.trace_id,
//           action: 'snooze',
//           note: 'Snoozed from dashboard'
//         })
//       });
//       toast.success('Item snoozed');
//       fetchSummary();
//     } catch (error) {
//       toast.error('Failed to snooze item');
//     }
//   };
// 
//   const handleResolve = async (item) => {
//     try {
//       await fetch(`${BACKEND_URL}/api/margin-guard/decisions`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           trace_id: item.trace_id,
//           action: 'resolve',
//           note: 'Resolved from dashboard'
//         })
//       });
//       toast.success('Item marked as resolved');
//       fetchSummary();
//     } catch (error) {
//       toast.error('Failed to resolve item');
//     }
//   };
// 
//   useEffect(() => {
//     fetchSummary();
//     fetchBrief();
//   }, [period]);
// 
//   useEffect(() => {
//     fetchBreakdowns();
//   }, [breakdownType, period]);
// 
//   if (loading) {
//     return (
//       <div className="min-h-screen bg-slate-950 flex items-center justify-center">
//         <div className="text-center">
//           <RefreshCw className="w-8 h-8 text-emerald-500 animate-spin mx-auto mb-4" />
//           <p className="text-slate-400">Loading Margin Guard...</p>
//         </div>
//       </div>
//     );
//   }
// 
//   return (
//     <div className="min-h-screen bg-slate-950 px-6 py-8">
//       <div className="max-w-7xl mx-auto">
//         {/* Back to Dashboard */}
//         <button
//           onClick={() => navigate('/dashboard')}
//           className="mb-4 text-sm text-slate-400 hover:text-slate-200 flex items-center gap-2 transition-colors"
//         >
//           <ArrowLeft className="w-4 h-4" />
//           Back to Dashboard
//         </button>
// 
//         {/* Header */}
//         <div className="flex items-start justify-between gap-4 mb-8">
//           <div>
//             <h1 className="text-3xl font-extrabold text-slate-100 flex items-center gap-3">
//               <Shield className="w-8 h-8 text-emerald-500" />
//               Margin Guard
//             </h1>
//             <p className="mt-1 text-slate-400">
//               Stop cancellations, backorders, and late deliveries from quietly bleeding profit.
//             </p>
//           </div>
// 
//           <div className="flex items-center gap-3">
//             <ShareReportDropdown
//               onEmail={handleSendBriefEmail}
//             />
// 
//             <select
//               value={period}
//               onChange={(e) => setPeriod(e.target.value)}
//               className="rounded-xl border border-slate-700 bg-slate-900 px-3 py-2 text-sm text-slate-100 focus:outline-none focus:ring-2 focus:ring-emerald-500"
//             >
//               <option value="7d">Last 7 days</option>
//               <option value="30d">Last 30 days</option>
//               <option value="90d">Last 90 days</option>
//             </select>
// 
//             <button 
//               onClick={handleRefresh}
//               disabled={refreshing}
//               className="rounded-xl border border-slate-700 bg-slate-900 p-2 text-slate-100 hover:bg-slate-800 transition-colors disabled:opacity-50"
//             >
//               <RefreshCw className={`w-5 h-5 ${refreshing ? 'animate-spin' : ''}`} />
//             </button>
//           </div>
//         </div>
// 
//         {/* Score Tiles */}
//         <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-8">
//           <ScoreTile
//             label="Margin Guard"
//             value={summary?.scores?.margin_guard}
//             delta={summary?.delta_7d?.margin_guard}
//             icon={Shield}
//             color="emerald"
//             tooltip="Composite score combining Promise, PCR, and Backorder metrics"
//           />
//           <ScoreTile
//             label="Promise (Business)"
//             value={summary?.scores?.promise_business}
//             delta={summary?.delta_7d?.promise_business}
//             icon={Clock}
//             color="blue"
//             tooltip="On-time fulfillment rate based on business day policy"
//           />
//           <ScoreTile
//             label="Expectation (Calendar)"
//             value={summary?.scores?.expectation_calendar}
//             delta={summary?.delta_7d?.expectation_calendar}
//             icon={TrendingUp}
//             color="violet"
//             tooltip="Late by customer expectation but within policy - CSAT risk"
//           />
//           <ScoreTile
//             label="PCR"
//             value={summary?.scores?.pcr}
//             delta={summary?.delta_7d?.pcr}
//             icon={XCircle}
//             color="amber"
//             tooltip="Preventable Cancellation Risk - excludes buyer remorse"
//           />
//           <ScoreTile
//             label="Backorder Risk"
//             value={summary?.scores?.backorder}
//             delta={summary?.delta_7d?.backorder}
//             icon={Package}
//             color="rose"
//             tooltip="Risk of unfulfilled orders based on inventory + velocity"
//           />
//         </div>
// 
//         {/* Weekly Brief Card */}
//         <WeeklyBriefCard
//           brief={brief}
//           onGenerate={handleGenerateBrief}
//           onViewFull={() => setShowFullBrief(true)}
//           onSendEmail={handleSendBriefEmail}
//           onSendSlack={handleSendBriefSlack}
//           generating={generatingBrief}
//           isSlackConnected={false}
//           planAllowsSlack={false}
//         />
// 
//         {/* Fix List */}
//         <div className="rounded-3xl border border-slate-800 bg-slate-900/40 p-6 mb-8">
//           <div className="flex items-center justify-between mb-4">
//             <div>
//               <h2 className="text-xl font-bold text-slate-100 flex items-center gap-2">
//                 <AlertTriangle className="w-5 h-5 text-amber-500" />
//                 This Week's Fix List
//               </h2>
//               <p className="mt-1 text-sm text-slate-400">Top 3 actions to protect margin. Every item has a trace.</p>
//             </div>
//             <button
//               onClick={() => navigate('/dashboard/margin-guard/orders')}
//               className="text-sm text-emerald-400 hover:text-emerald-300 font-medium flex items-center gap-1"
//             >
//               View all orders
//               <ArrowRight className="w-4 h-4" />
//             </button>
//           </div>
// 
//           <div className="space-y-4">
//             {summary?.fix_list?.length === 0 ? (
//               <div className="text-center py-8 text-slate-400">
//                 <CheckCircle className="w-12 h-12 mx-auto mb-3 text-emerald-500" />
//                 <p>No urgent fixes needed! Your operations are healthy.</p>
//               </div>
//             ) : (
//               summary?.fix_list?.slice(0, 3).map((item) => (
//                 <FixItemCard
//                   key={item.id}
//                   item={item}
//                   onReviewTrace={handleReviewTrace}
//                   onSendToSlack={handleSendToSlack}
//                   onSnooze={handleSnooze}
//                   onResolve={handleResolve}
//                 />
//               ))
//             )}
//           </div>
//         </div>
// 
//         {/* Breakdowns */}
//         <div className="rounded-3xl border border-slate-800 bg-slate-900/40 p-6">
//           <div className="flex items-center justify-between mb-4">
//             <h2 className="text-xl font-bold text-slate-100 flex items-center gap-2">
//               <BarChart3 className="w-5 h-5 text-blue-500" />
//               Breakdowns
//             </h2>
//             <div className="flex items-center gap-2">
//               <BreakdownTab
//                 active={breakdownType === 'node'}
//                 label="By Node"
//                 icon={Layers}
//                 onClick={() => setBreakdownType('node')}
//               />
//               <BreakdownTab
//                 active={breakdownType === 'region'}
//                 label="By Region"
//                 icon={MapPin}
//                 onClick={() => setBreakdownType('region')}
//               />
//               <BreakdownTab
//                 active={breakdownType === 'method'}
//                 label="By Method"
//                 icon={Truck}
//                 onClick={() => setBreakdownType('method')}
//               />
//               <BreakdownTab
//                 active={breakdownType === 'sku'}
//                 label="By SKU"
//                 icon={Box}
//                 onClick={() => setBreakdownType('sku')}
//               />
//             </div>
//           </div>
// 
//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead>
//                 <tr className="border-b border-slate-800">
//                   <th className="text-left py-3 px-4 text-xs font-semibold text-slate-400 uppercase">Name</th>
//                   <th className="text-right py-3 px-4 text-xs font-semibold text-slate-400 uppercase">Margin Guard</th>
//                   <th className="text-right py-3 px-4 text-xs font-semibold text-slate-400 uppercase">Promise</th>
//                   <th className="text-right py-3 px-4 text-xs font-semibold text-slate-400 uppercase">PCR</th>
//                   <th className="text-right py-3 px-4 text-xs font-semibold text-slate-400 uppercase">Backorder</th>
//                   <th className="text-right py-3 px-4 text-xs font-semibold text-slate-400 uppercase">Orders</th>
//                   <th className="text-right py-3 px-4 text-xs font-semibold text-slate-400 uppercase">At Risk</th>
//                   <th className="text-right py-3 px-4 text-xs font-semibold text-slate-400 uppercase">7d Δ</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {breakdowns.map((row) => (
//                   <tr key={row.entity_id} className="border-b border-slate-800/50 hover:bg-slate-800/30">
//                     <td className="py-3 px-4 text-sm font-medium text-slate-200">{row.entity_name}</td>
//                     <td className="py-3 px-4 text-sm text-right">
//                       <span className={`font-semibold ${row.margin_guard_score >= 80 ? 'text-emerald-400' : row.margin_guard_score >= 60 ? 'text-amber-400' : 'text-rose-400'}`}>
//                         {row.margin_guard_score}
//                       </span>
//                     </td>
//                     <td className="py-3 px-4 text-sm text-right text-slate-300">{row.promise_score}</td>
//                     <td className="py-3 px-4 text-sm text-right text-slate-300">{row.pcr_score}</td>
//                     <td className="py-3 px-4 text-sm text-right text-slate-300">{row.backorder_score}</td>
//                     <td className="py-3 px-4 text-sm text-right text-slate-300">{row.order_count.toLocaleString()}</td>
//                     <td className="py-3 px-4 text-sm text-right">
//                       <span className={row.at_risk_count > 20 ? 'text-rose-400 font-medium' : 'text-slate-300'}>
//                         {row.at_risk_count}
//                       </span>
//                     </td>
//                     <td className="py-3 px-4 text-sm text-right">
//                       <span className={`${row.delta_7d >= 0 ? 'text-emerald-400' : 'text-rose-400'}`}>
//                         {row.delta_7d >= 0 ? '+' : ''}{row.delta_7d}
//                       </span>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
// 
//         {/* Weights Legend */}
//         <div className="mt-6 flex items-center justify-center gap-6 text-xs text-slate-500">
//           <span>Score Weights:</span>
//           <span className="flex items-center gap-1">
//             <Clock className="w-3 h-3" /> Promise 45%
//           </span>
//           <span className="flex items-center gap-1">
//             <XCircle className="w-3 h-3" /> PCR 30%
//           </span>
//           <span className="flex items-center gap-1">
//             <Package className="w-3 h-3" /> Backorder 25%
//           </span>
//         </div>
//         
//         {/* Quick Actions */}
//         <div className="mt-6 flex items-center justify-center gap-3">
//           <button
//             onClick={() => navigate('/dashboard/margin-guard/orders')}
//             className="px-4 py-2 bg-slate-800 hover:bg-slate-700 text-slate-200 rounded-lg text-sm font-medium transition-colors flex items-center gap-2"
//           >
//             <BarChart3 className="w-4 h-4" />
//             View Orders
//           </button>
//           <button
//             onClick={() => navigate('/dashboard/settings/promise-wizard')}
//             className="px-4 py-2 bg-slate-800 hover:bg-slate-700 text-slate-200 rounded-lg text-sm font-medium transition-colors flex items-center gap-2"
//           >
//             <Settings className="w-4 h-4" />
//             Configure
//           </button>
//         </div>
//       </div>
// 
//       {/* Enhanced Trace Viewer */}
//       <TraceViewer
//         traceId={selectedTraceId}
//         isOpen={!!selectedTraceId}
//         onClose={() => {
//           setSelectedTraceId(null);
//           setTrace(null);
//           // Clear URL if we navigated via URL
//           if (urlTraceId) {
//             navigate('/dashboard/margin-guard');
//           }
//         }}
//       />
// 
//       {/* Full Brief Modal */}
//       <FullBriefModal
//         brief={brief}
//         isOpen={showFullBrief}
//         onClose={() => setShowFullBrief(false)}
//       />
//     </div>
//   );
// }
// END ORIGINAL SOURCE

export default function HeldMarginGuardPage() { return <MarginGuardHeld/>; }
